<template>
  <div class="row">
    <div class="col-6">
      <label>Profissional</label>
      <div class="input-group input-focus">
        <a-auto-complete style="width: 200px" @search="handleSearch" class="form-control form-input-component">
          <template v-slot:dataSource>
            <a-select-option v-for="item in profissionaisSearch" :key="item.nome" :value="item.nome" @click="onSelectPro(item.id)">
              {{ item.nome }}
            </a-select-option>
          </template>
        </a-auto-complete>
      </div>
    </div>
    <div class="col-3">
      <label>Modo de Consulta</label>
      <select class="form-select form-input-component" ref="modoConsulta" v-model="formConsult.tipoAgendamento">
        <option v-for="item in tipoAgenda" :key="item" :value="item.tipo">
          {{ item.descricao }}
        </option>
      </select>
    </div>
    <div class="col-3">
      <label>Categoria do Atendimento</label>
      <select class="form-select form-input-component" ref="catAtendimento" v-model="formConsult.categoriaAtendimento">
        <option v-for="item in categorias" :key="item" :value="item.descricao">
          {{ item.descricao }}
        </option>
      </select>
    </div>

    <div class="col-2">
      <label>Início</label>
      <a-form-item>
        <a-date-picker class="form-control form-input-component" show-time type="date" placeholder="Data inicio" format="DD/MM/yyyy" style="width: 100%" v-model:value="dataInicio" />
      </a-form-item>
    </div>
    <div class="col-2">
      <label>Fim</label>
      <a-form-item>
        <a-date-picker class="form-control form-input-component" show-time type="date" format="DD/MM/yyyy" placeholder="Data fim" style="width: 100%" v-model:value="dataFim" />
      </a-form-item>
    </div>
    <div class="col-2">
      <label>Unidade</label>
      <select class="form-select" ref="catUnidade" v-model="formConsult.unidadeAtendimento">
        <option v-for="item in unidadeAtendimento" :key="item.descricao" :value="item.descricao">
          {{ item.descricao }}
        </option>
      </select>
    </div>
    <div class="col-5">
      <label>Paciente</label>
      <div class="input-group input-focus">
        <a-auto-complete style="width: 200px" @search="handleSearchPaciente" class="form-control">
          <template v-slot:dataSource>
            <a-select-option v-for="item in pacientesSearch" :key="item.id" :value="item.nome" @click="onSelectPac(item.id)">
              {{ item.nome }}
            </a-select-option>
          </template>
        </a-auto-complete>
      </div>
    </div>
    <div class="col-1" style="">
      <div class="input-group-prepend" style="margin-top: 23px">
        <span class="input-group-text bg-white" @click="searchAgendados"><i class="fa fa-search"></i></span>
      </div>
    </div>
  </div>
  <a-table :dataSource="todosAtendimentos" :columns="columns">
    <template #paciente="{ record }">
      <a-tooltip title="Editar paciente" placement="right">
        <span @click="editarPaciente(record.paciente)">{{ record.paciente.nome }}</span>
      </a-tooltip>
    </template>
    <template #tipoAgendamento="{ record }">
      <div class="col col-icon">
        <div v-if="record.tipoAgendamento === 'VIRTUAL'">
          <a-tooltip title="Alterar para Presencial" placement="right">
            <i class="fa-solid fa-desktop icon-atendimento" @click="alterarAgendamento(record.id, 'PRESENCIAL', null)"></i>
          </a-tooltip>
          <a-tooltip title="Gerar link" placement="right">
            <div class="row">
              <span>Gerar link da reunião <i class="fa-solid fa-link"></i></span>
            </div>
          </a-tooltip>
        </div>
        <a-tooltip title="Alterar para Virtual" placement="right" v-if="record.tipoAgendamento === 'PRESENCIAL'">
          <i class="fa-solid fa-people-carry-box icon-atendimento" @click="alterarAgendamento(record.id, 'VIRTUAL', null)"></i>
        </a-tooltip>
      </div>
    </template>
    <template #valorAtendimento="{ record }">
      <div v-if="record.valorAtendimento">
        {{ formatarValorTable(record.valorAtendimento) }}
      </div>
      <div v-if="!record.valorAtendimento">
        <a-tooltip title="Atribuir valor" placement="right">
          <i class="fa-solid fa-hand-holding-dollar icon-atendimento" @click="abrirModalAtribuirValor(record)"></i>
        </a-tooltip>
      </div>
    </template>
    <template #situacao="{ record }">
      <select class="form-select" ref="situacao" v-model="record.situacao" @change="alterarAgendamento(record.id, null, record.situacao)">
        <option v-for="item in situacaoAtendimento" :key="item" :value="item">
          {{ item }}
        </option>
      </select>
    </template>
  </a-table>

  <Dialog header="Atribuir Valor Atendimento" v-model:visible="showAtribuirValor">
    <div class="row">
      <span><strong>Profissional:</strong> {{ atendimentoSelecionado.nomeProfissional }}</span>
    </div>
    <div class="row">
      <span><strong>Paciente: </strong>{{ atendimentoSelecionado.paciente.nome }}</span>
    </div>
    <div class="row">
      <label>Valor Total</label>
      <div class="input-group input-focus">
        <input type="text" class="form-control form-input-component" @input="formatarValor" v-model="valorAtribuido" />
      </div>
    </div>
    <div class="row">
      <div style="margin-top: 23px; margin-bottom: 10px">
        <button type="button" class="btn btn-primary" @click="atribuirValor" style="margin-right: 10px">Atribuir valor</button>
      </div>
    </div>
  </Dialog>
</template>

<script>
import { getProfissional } from '@/components/service/profissionalService';
import { EnumTipoAgenda } from '@/components/models/enumTipoAgenda';
import { getPaciente } from '@/components/service/pacienteService';
import { formatMoney, getCategoriaAtendimento, getUnidadeAtendimento } from '@/config/servicos-utils';
import { openNotification, typesNotification } from '@/utils/notifications';
import { consultarAgendamento, updateAgendamento } from '@/components/service/agendamento-medico';
import { EnumTipoSituacao } from '@/components/models/enumSituacaoAtendimento';

export default {
  name: 'GerirAtendimentoSecretaria',
  props: {},
  data() {
    return {
      selectedDate: null,
      showAtribuirValor: false,
      atendimentoSelecionado: null,
      profissionaisSearch: [],
      valorAtribuido: 0,
      pacientesSearch: [],
      tipoAgenda: EnumTipoAgenda(),
      categorias: [],
      unidadeAtendimento: [],
      todosAtendimentos: [],
      dataInicio: null,
      dataFim: null,
      situacaoAtendimento: EnumTipoSituacao(),
      formConsult: {
        idProfissional: null,
        tipoAgendamento: null,
        categoriaAtendimento: null,
        unidadeAtendimento: null,
        dataInicio: null,
        dataFim: null,
        idPaciente: null,
      },
      columns: [
        {
          title: 'Data',
          dataIndex: 'data',
          key: 'data',
          slots: { customRender: 'data' },
        },
        {
          title: 'Horário',
          dataIndex: 'horario',
          key: 'horario',
          slots: { customRender: 'horario' },
        },
        {
          title: 'Paciente',
          dataIndex: 'paciente',
          key: 'paciente',
          slots: { customRender: 'paciente' },
        },
        {
          title: 'Modo da Consulta',
          dataIndex: 'tipoAgendamento',
          key: 'tipoAgendamento',
          slots: { customRender: 'tipoAgendamento' },
        },
        {
          title: 'Profissional',
          dataIndex: 'nomeProfissional',
          key: 'nomeProfissional',
          slots: { customRender: 'nomeProfissional' },
        },
        {
          title: 'Categoria do Atendimento',
          dataIndex: 'categoriaAtendimento',
          key: 'categoriaAtendimento',
          slots: { customRender: 'categoriaAtendimento' },
        },
        {
          title: 'Unidade',
          dataIndex: 'unidadeAtendimento',
          key: 'unidadeAtendimento',
          slots: { customRender: 'unidadeAtendimento' },
        },
        {
          title: 'Valor',
          dataIndex: 'valorAtendimento',
          key: 'valorAtendimento',
          slots: { customRender: 'valorAtendimento' },
        },
        {
          title: 'Situação',
          dataIndex: 'situacao',
          key: 'situacao',
          slots: { customRender: 'situacao' },
        },
      ],
    };
  },
  async created() {
    await this.getCategoria();
    await this.getUnidade();
  },
  methods: {
    async handleSearch(value) {
      value.length >= 3
        ? await getProfissional({ nome: value }).then((r) => {
            this.profissionaisSearch = r.data.profissionais;
          })
        : (this.profissionaisSearch = []);
    },
    async handleSearchPaciente(value) {
      value.length >= 3
        ? await getPaciente({ nome: value }).then((r) => {
            console.log(r.data);
            this.pacientesSearch = r.data.pacientes;
          })
        : (this.pacientesSearch = []);
    },
    async getCategoria() {
      await getCategoriaAtendimento().then((r) => {
        this.categorias = r.data;
      });
    },
    async getUnidade() {
      await getUnidadeAtendimento().then((r) => {
        this.unidadeAtendimento = r.data;
      });
    },
    async searchAgendados() {
      let validate = this.verificarCampoPesquisa();
      if (validate) {
        await consultarAgendamento(this.formConsult).then((r) => {
          this.todosAtendimentos = r.data;
        });
      } else {
        openNotification(typesNotification.warning, 'Necessário algum campo preenchido para realizar a consulta.');
      }
    },
    onSelectPro(idPro) {
      this.formConsult.idProfissional = idPro;
      localStorage.setItem('idProf', idPro);
    },
    onSelectPac(idPac) {
      this.formConsult.idPaciente = idPac;
    },
    verificarCampoPesquisa() {
      let validate = true;
      this.formConsult.dataInicio = this.dataInicio;
      this.formConsult.dataFim = this.dataFim;
      if (!this.formConsult.idProfissional && !this.formConsult.tipoAgendamento && !this.formConsult.categoriaAtendimento && !this.dataInicio && !this.formConsult.unidadeAtendimento && !this.formConsult.idPaciente) {
        validate = false;
      }
      return validate;
    },
    editarPaciente(paciente) {
      if (paciente.tipoPaciente === 'MILITAR') {
        this.$router.push({ path: '/form-paciente-militar/edit', query: { id: paciente.id } });
      } else {
        this.$router.push({ path: '/form-paciente-dependente/edit', query: { id: paciente.id } });
      }
    },
    abrirModalAtribuirValor(atendimento) {
      this.showAtribuirValor = true;
      this.atendimentoSelecionado = atendimento;
    },
    async alterarAgendamento(id, tipoAtendimento, situacao) {
      await updateAgendamento({ id: id, tipoAtendimento: tipoAtendimento, situacao: situacao }).then(async () => {
        await this.searchAgendados();
      });
    },
    async formatarValor() {
      this.valorAtribuido = formatMoney(this.valorAtribuido);
    },
    formatarValorTable(valor) {
      return formatMoney(String(valor));
    },
    async atribuirValor() {
      let valorSave = this.splitMoney();
      await updateAgendamento({ id: this.atendimentoSelecionado.id, valorAtendimento: valorSave }).then(async () => {
        await this.searchAgendados();
        this.showAtribuirValor = false;
        this.valorAtribuido = 0;
        openNotification(typesNotification.success, 'Valor Atribuído com sucesso.');
      });
    },
    splitMoney() {
      return this.valorAtribuido.replace(/\D/g, '');
    },
  },
};
</script>

<style scoped>
.icon-atendimento {
  margin-left: 30px;
  font-size: 25px;
  cursor: pointer;
}

.icon-atendimento:hover {
  color: #03315f;
  text-shadow: 0 0 3px #03315f;
}

.gerar-link {
  text-align: center;
  font-size: 9px;
  cursor: pointer;
}

.paciente {
  font-size: 10px;
  cursor: pointer;
}
</style>
